module.exports = __webpack_public_path__ + "static/media/corporate-services-img36.554ca3d0.jpg";